/* global window */
import { loadScript } from './loadScript';

function loadSdk(): Promise<any> {
    return new Promise((resolve, reject) => {

        if (window["YT"] && window["YT"].Player && window["YT"].Player instanceof Function) {
            resolve(window["YT"]);
            return;
        }

        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        if (!window["onYouTubeIframeAPIReady"]) {
            window["onYouTubeIframeAPIReady"] = () => {
                resolve(resolve(window["YT"]));
            };
        }

        const url = window.location.protocol + '//www.youtube.com/iframe_api'; 
        loadScript(url)
            .catch((err: any) => {
                reject(err);
            });
    });
}

let sdk: Promise<any> = null;

export default function getYoutubeSdk() {
    if (!sdk) {
        sdk = loadSdk();
    }
    return sdk;
}